import { useRef } from "react";
import { useDispatch } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataPDF } from "../utils/fetchData";

export function usePdfDownloader() {
	const lastBrochureRef = useRef({ file: null, url: null });
	const debounceRef = useRef(null);
	const dispatch = useDispatch();

	const downloadPdf = async (file) => {
		if (debounceRef.current) clearTimeout(debounceRef.current);
		debounceRef.current = setTimeout(async () => {
			if (
				lastBrochureRef.current.file === file &&
				lastBrochureRef.current.url
			) {
				window.open(lastBrochureRef.current.url, "_blank");
				return;
			}
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
			try {
				const newfile = { file };
				const res = await getDataPDF(`getCoursePdf`, newfile, {
					responseType: "blob",
				});
				const fileURL = URL.createObjectURL(res.data);
				lastBrochureRef.current = { file, url: fileURL };
				window.open(fileURL, "_blank");
			} catch (err) {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				alert(
					"Failed to fetch the file. Please check your connection or try again later."
				);
			}
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
		}, 200);
	};

	return downloadPdf;
}
